import { Component, Input } from '@angular/core'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large'
import { BodyLarge } from '../../components/typography/body-large/body-large'
import { Title } from '../../components/typography/title/title'

@Component({
	selector: 'app-three-cards-with-images',
	imports: [HeadlineLarge, BodyLarge, Title],
	templateUrl: './three-cards-with-images.html',
	styleUrl: './three-cards-with-images.css',
})
export class ThreeCardsWithImages {
	@Input() content!: ComponentWithCopy
}
